import * as React from "react";
import { toJS } from "mobx";
import clsx from "clsx";
import {
  Grid,
  Typography,
  Input,
  RadioGroup,
  FormControlLabel,
  Button,
  Radio,
  withStyles,
  FormControl,
} from "@material-ui/core";
import { observer } from "mobx-react";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import i18n from "i18n";
import * as _ from "lodash";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { LibraryStore } from "modules/library/LibraryStore";
import { gtag } from "ga-gtag";
import ReactSelect from "common/components/ReactSelect";
import { EModelMapType } from "common/enums";

const styles = () => ({
  root: {
    left: 0,
    zIndex: 2,
    top: 0,
    height: "calc(100vh - 113px)",
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    position: "absolute" as any,
    minHeight: "615px",
  },
  container: {
    top: 0,
    left: 0,
    zIndex: 2,
    height: "100%",
    width: "100%",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    backgroundColor: "#FFF",
    position: "absolute" as any,
    overflow: "hidden",
  },
  layerTitleContainer: {
    marginTop: 30,
    marginBottom: 30,
  },
  layerTitle: {
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: 400,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "610px",
    margin: "0 auto",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  inputCenter: {
    "& input": { textAlign: "center" as any, marginBottom: 40.5 },
  },
  inputSelect: { marginBottom: 40.5, width: "710px" },
  label: {
    fontFamily: "Roboto",
    fontSize: "12px",
    letterSpacing: "1.2px",
    color: "#000000DE",
    textTransform: "uppercase" as any,
    marginBottom: 15,
  },
  radioLabel: {
    fontFamily: "Raleway",
    fontSize: "12px",
    fontWeight: 400,
    color: "#5C5C5C",
  },
  buttonContainer: {
    position: "absolute" as any,
    width: "100%",
    bottom: "50px",
  },
  button: {
    height: "36px",
    width: "106px",
    background: "#ABC200",
    "&:hover": {
      background: "#92A501",
    },
    marginLeft: 8,
    marginRight: 8,
  },
  buttonCancel: {
    height: "36px",
    width: "106px",
    background: "#ABABAB",
    "&:hover": {
      background: "#8f8f8f",
    },
    marginLeft: 8,
    marginRight: 8,
  },
});

type TListValue = { value: number; label: string; color?: string };

type IState = {
  name: string;
  allModels: boolean;
  categoriesSelected: TListValue[];
  ifcsSelected: TListValue[];
  index: number;
  categories: string[];
};

type IProps = {
  classes: any;
};

@observer
class LayerAddModelMap extends React.Component<IProps, IState> {
  state = {
    name: "",
    allModels: true,
    index: 0,
    ifcsSelected: new Array<TListValue>(),
    categoriesSelected: new Array<TListValue>(),
    categories: new Array<string>(),
  };

  componentDidMount = async () => {
    const modelMap = TakeOffStore.takeOffModelMap;
    await TakeOffStore.fetchTakeOffFormatedList();

    if (modelMap) {
      const { name, useAllModels, files, modelErrors, types } = modelMap.data;
      await this.loadAllFiles(useAllModels, files, modelErrors);
      await this.loadAllCategories(useAllModels, files, types);

      this.setState({
        name: name,
        allModels: Boolean(useAllModels == undefined || useAllModels == true),
      });
    } else {
      await this.loadAllCategories(true);
    }
  };

  handleClickCancel = () => {
    TakeOffStore.layerTakeOffEdit = "";
  };

  handleNext = async () => {
    const { name, allModels, ifcsSelected, categoriesSelected } = this.state;

    TakeOffStore.setTakeOffLoading(true);
    ModelMapStore.saveModelMapsConfiguration(
      false,
      name,
      allModels,
      ifcsSelected.map((lib) => lib.label),
      categoriesSelected.map((cat) => cat.label)
    ).finally(() => {
      TakeOffStore.setTakeOffLoading(false);
    });
  };

  handleSave = async () => {
    gtag("event", "editar_model_map", {
      editar_model_map: 0,
    });

    const { name, allModels, ifcsSelected, categoriesSelected } = this.state;

    TakeOffStore.setTakeOffLoading(true);
    ModelMapStore.saveModelMapsConfiguration(
      true,
      name,
      allModels,
      ifcsSelected.map((lib) => lib.label),
      categoriesSelected.map((cat) => cat.label)
    ).finally(() => {
      TakeOffStore.setTakeOffLoading(false);
    });
  };

  handleChange = (options) => {
    this.setState({ categoriesSelected: options });
  };

  handleChangeName = (event) => {
    this.setState({ name: event.target.value });
  };

  handleChangeIfc = (options) => {
    this.setState({ ifcsSelected: options });
    this.loadAllCategoriesByState(this.state.allModels, options);
  };

  handleChangeAllModels = async (ev) => {
    let value = ev.target.value === "true";
    await this.setState({ allModels: value });
    await this.loadAllCategoriesByState(value);
  };

  renderTitle(isEditing: boolean, type?: EModelMapType): string {
    const label = i18n.modelMaps.addLayer;
    const isElement = type == EModelMapType.ELEMENT_CONSTRUCTIVE;
    if (isEditing) {
      return isElement ? label.headerECView : label.headerMatView;
    }
    return isElement ? label.headerEC : label.headerMat;
  }

  loadAllFiles(
    allModels: boolean,
    filesIds: string[] = [],
    modelErrors: any[] = []
  ) {
    const files: TListValue[] = [];
    if (!allModels) {
      // Carrega os Model Maps
      LibraryStore.libraries.forEach(async (lib, index) => {
        if (filesIds.includes(lib.id)) {
          let label = LibraryStore.getLibrariesLabelName(lib);
          files.push({
            label,
            value: index,
          });
        }
      });

      // Carrega os erros no fim da lista
      if (modelErrors.length) {
        for (const { label } of modelErrors) {
          let library = LibraryStore.findLibrayByLabelName(label);
          if (!library) {
            files.push({
              label,
              value: files.length,
              color: "#FFD8D8",
            });
          }
        }
      }
    }
    this.setState({ ifcsSelected: files });
  }

  async loadAllCategoriesByState(allModels: boolean, files: TListValue[] = []) {
    files = files.length ? files : this.state.ifcsSelected;
    const ifcs = files.map((op) => {
      const libFounded = LibraryStore.findLibrayByLabelName(op.label);
      return libFounded ? libFounded.id : "";
    });
    this.loadAllCategories(
      allModels,
      ifcs,
      this.state.categoriesSelected.map((cat) => cat.label)
    );
  }

  async loadAllCategories(
    allModels: boolean,
    filesIds: string[] = [],
    categorieslabels: string[] = []
  ) {
    // Recupera os ifcs que estão sendo usados nesse projeto
    filesIds = await LibraryStore.getOnlyExistingLibraries(allModels, filesIds);
    const categories = await ModelMapStore.loadCategories(filesIds);

    // Filtra e monta objeto com opção selecionada de categoria
    const selected = categorieslabels;
    const newSelected: TListValue[] = [];

    categories.forEach((cat, index) => {
      if (selected.includes(cat)) {
        newSelected.push({
          label: cat,
          value: index,
        });
      }
    });

    this.setState({
      categoriesSelected: newSelected,
      categories,
    });
  }

  render() {
    const { classes } = this.props;
    const { allModels, categoriesSelected, categories, name } = this.state;

    const modelMap: any = TakeOffStore.takeOffModelMap
      ? TakeOffStore.takeOffModelMap.data
      : { types: [], files: [] };
    const files = LibraryStore.libraries.map((lib) =>
      LibraryStore.getLibrariesLabelName(lib)
    );

    const isEditing = TakeOffStore.layerTakeOffEdit == "edit";
    const canSave = categoriesSelected.length && name.length;
    const type = ModelMapStore.typeSelected;

    return (
      <div className={classes.root}>
        <Grid container className={classes.container}>
          <div style={{ textAlign: "center", height: "100vh" }}>
            <div className={classes.layerTitleContainer}>
              <Typography className={classes.layerTitle} component="h2">
                {this.renderTitle(isEditing, type)}
              </Typography>
            </div>
            <Input
              autoFocus
              value={name}
              className={clsx(classes.input, classes.inputCenter)}
              placeholder={i18n.modelMaps.addLayer.modelName}
              onChange={this.handleChangeName}
            />
            <div className={classes.label}>
              {i18n.modelMaps.addLayer.models}
            </div>
            <RadioGroup
              className={classes.input}
              style={{
                marginBottom: allModels ? 22 : 40,
              }}
              name="allmodels"
              value={allModels ? "true" : "false"}
              onChange={this.handleChangeAllModels}
            >
              <FormControlLabel
                classes={{ label: classes.radioLabel }}
                value="true"
                control={<Radio style={{ color: "#ABC200" }} />}
                label={i18n.modelMaps.addLayer.useAllModels}
              />
              <FormControlLabel
                classes={{ label: classes.radioLabel }}
                value="false"
                control={<Radio style={{ color: "#ABC200" }} />}
                label={i18n.modelMaps.addLayer.filterModels}
              />
            </RadioGroup>
            {!allModels && (
              <FormControl className={clsx(classes.input, classes.inputSelect)}>
                <ReactSelect
                  listValues={files}
                  handleChange={this.handleChangeIfc}
                  modelErrors={
                    modelMap.modelErrors
                      ? modelMap.modelErrors.map((m) => m.label)
                      : []
                  }
                  value={this.state.ifcsSelected}
                  placeholder={i18n.modelMaps.addLayer.modelIFC}
                  isMulti
                />
              </FormControl>
            )}
            <div
              className={classes.label}
              style={{
                marginBottom: 22,
              }}
            >
              {type === "EC"
                ? i18n.modelMaps.addLayer.constructiveElements
                : i18n.modelMaps.addLayer.Materials}
            </div>
            <FormControl
              className={classes.input}
              style={{
                marginBottom: !allModels ? 72 : 130,
              }}
            >
              <ReactSelect
                listValues={categories}
                handleChange={this.handleChange}
                categoryErrors={
                  modelMap.categoryErrors
                    ? modelMap.categoryErrors.filter(
                        (ce) => categories.findIndex((lc) => lc == ce) == -1
                      )
                    : []
                }
                value={categoriesSelected}
                placeholder={i18n.modelMaps.addLayer.modelCategories}
                isMulti
              />
            </FormControl>
            {isEditing ? (
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonCancel}
                  onClick={this.handleClickCancel}
                >
                  {i18n.cancel}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={this.handleSave}
                  disabled={!canSave}
                >
                  {i18n.save}
                </Button>
              </div>
            ) : (
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={this.handleNext}
                  disabled={!canSave}
                >
                  {i18n.continue}
                </Button>
              </div>
            )}
          </div>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(LayerAddModelMap);



// WEBPACK FOOTER //
// ./src/modules/modelMap/components/layouts/LayerAddModelMap.tsx